import {AirtablePromotionItem} from '../../models/airtable';
import apiService from '../../transport/apiService';
import {logger, serializeError} from '../../utils/logger';

/**
 * Moved verbatim from `promotionsStore.loadLinkedProducts` (DIS-1567). Not a
 * query: linked products are not cached here because a promotion can be viewed
 * from several places, and each promotion screen keeps its own list in local
 * state (`PromotionDetailScreen.tsx`).
 */
export const loadLinkedProducts = (promotion?: AirtablePromotionItem) => {
  if (!promotion?.barcodes?.length) {
    return [];
  }

  return apiService
    .searchByBarcode(promotion.barcodes)
    .then(data => data)
    .catch(err => {
      logger.error('promotions', 'Error loading promotion linked products', serializeError(err));
      return [];
    });
};
